export function getUrlForAuthPage(isPageInAppView: boolean) {
  if (isPageInAppView) {
    return '/home/join?flow=authenticate&redirecturl=/vip'
  }
  return '/home/join?flow=register&redirecturl=/vip'
}

export function getVipFamilyUrl() {
  return '/home/join/?flow=authenticate&redirecturl=/next-profile/profile?tab=vip_family'
}
